import getAuthorizationHeader from './getAuthorizationHeader'

export default async function getHeaders(
  customHeaders?: Record<string, string>,
): Promise<Record<string, string>> {
  const headers = await getAuthorizationHeader()
  return { ...headers, ...customHeaders }
}
